<template>
<div class="export" v-if="profile.admin">
    <h1 class="subheading grey--text">Eksporter data</h1>
    <v-container class="mt-1">
        <v-data-table :headers="headers" :items="collections" class="elevation-1" :pagination.sync="pagination" rows-per-page-text="Rækker per side">
            <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td class="text-xs-left">
                    <v-switch name="admin" label="" v-model="props.item.export"></v-switch>
                </td>

            </template>
        </v-data-table>
        <v-btn flat class="success mx-0 mt-3" @click="submit" :loading="loading">Eksporter</v-btn>
    </v-container>
</div>
</template>

<script>
const fs = require('fs');
export default {
    data() {
        return {
            pagination: {
                rowsPerPage: 10
            },
            loading: false,                        
            collections: [{
                name: "users",
                export: true
            },
            {
                name: "horses",
                export: true
            },
            {
                name: "bookings",
                export: true
            },
            {
                name: "config",
                export: true
            },
            {
                name: "resources",
                export: true
            },            
            ],
            headers: [{
                    text: 'Navn',
                    align: 'left',
                    value: 'name'
                },   
{
                    text: 'Ekxporter',
                    align: 'left',
                    value: 'export'
                },                               
            ],            
        }
    },
    computed: {
        profile() {
            return this.$store.getters.profile
        },
        db() {
            return this.$store.state.db
        },        
    },
    methods: {
        submit() {
            this.loading = true;
            this.exportCollections();
            this.loading = false;
        },
        exportCollections(){
            var data = {};
            this.collections.forEach(collection => {
                console.log("Collection: " +  collection.name)
            
                this.db.collection(collection.name)
                .get()
                .then(snapshot => {
                snapshot.forEach(doc => {
                    data[collection.name][doc.id] = doc.data();
                })
                return data;
                })
                .catch(error => {
                console.log(error);
                })

                               
                // Write collection to JSON file
                fs.writeFile(collection.name + "firestore-export.json", JSON.stringify(data), function(err) {
                    if(err) {
                        return console.log(err);
                    }
                    console.log("The file was saved!");
                }); 
 
            })                        
        },    

    },
    mounted() {

    }    
}       
</script>

<style scoped>

</style>
